import "../../../packages/shared/css/fonts.css";
import "../../../packages/shared/css/variables.css";
import "../../../packages/shared/css/base.css";
import "../../../packages/app-ui/css/base/layout.css";
import "../../../packages/app-ui/css/components/library-controls.css";
import "../../../packages/app-ui/css/components/upload-controls.css";
import "../../../packages/app-ui/css/components/file-status.css";
import "../../../packages/app-ui/css/components/transcript-shell.css";
import "../../../packages/app-ui/css/components/transcript-stats.css";
import "../../../packages/app-ui/css/components/transcript-pending.css";
import "../../../packages/app-ui/css/components/notifications.css";
import "../../../packages/app-ui/css/components/quota-modal.css";
import "../../../packages/app-ui/css/components/mobile-tabs.css";
import "../../../packages/app-ui/css/components/bottom-sheet.css";
import "../../../packages/app-ui/css/states/library.css";
import "../../../packages/app-ui/css/indoc-search.css";
import "./app.css";
import "../../../packages/shared/js/custom-scrollbar.js";

import { createClerkClient } from "./auth/clerkClient.js";
import { createAppShell } from "./ui/appShell.js";
import { mountProductApp } from "./productApp.js";
import { installPerfTimer } from "./utils/perfTimer.js";
import { createMobileTabs } from "../../../packages/app-ui/js/mobileTabs.js";
import { createMobileFilters } from "../../../packages/app-ui/js/mobileFilters.js";
import { createTranscriptOverflow } from "../../../packages/app-ui/js/transcriptOverflow.js";

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

const perf = installPerfTimer();
const clerkClient = createClerkClient(clerkPubKey);
let mobileTabs = null;
let mobileFilters = null;
let transcriptOverflow = null;

async function main() {
  perf.startTimer("app-init");
  perf.startTimer("clerk-load");
  await clerkClient.load();
  perf.endTimer("clerk-load");
  const appRoot = document.getElementById("app");
  if (!appRoot) {
    throw new Error("app root not found");
  }
  const shell = await createAppShell(appRoot);
  let activeApp = null;
  let isMounting = false;
  let currentSignedIn = clerkClient.isSignedIn();

  async function mountApp() {
    if (isMounting) return;
    isMounting = true;
    perf.startTimer("mount-app");
    try {
      const layout = shell.renderAppLayout();
      activeApp = await mountProductApp({
        shellElements: layout,
        apiBaseUrl,
        clerkClient,
      });
      // Initialize mobile tab bar after app is mounted
      if (!mobileTabs) {
        mobileTabs = createMobileTabs({ document, window });
      }
      mobileTabs.init();
      // Initialize mobile filters bottom sheet
      if (!mobileFilters) {
        mobileFilters = createMobileFilters({ document, window });
      }
      mobileFilters.init();
      // Initialize transcript overflow menu for mobile
      if (!transcriptOverflow) {
        transcriptOverflow = createTranscriptOverflow({ document, window });
      }
      transcriptOverflow.init();
    } catch (error) {
      console.error("app_mount_failed", error);
      showSignIn();
    } finally {
      isMounting = false;
      perf.endTimer("mount-app");
    }
  }

  function showSignIn() {
    activeApp = null;
    if (mobileTabs) {
      mobileTabs.destroy();
    }
    if (mobileFilters) {
      mobileFilters.destroy();
    }
    if (transcriptOverflow) {
      transcriptOverflow.destroy();
    }
    const { signInElement } = shell.renderSignedOut();
    clerkClient.mountSignIn(signInElement);
  }

  if (currentSignedIn) {
    await mountApp();
  } else {
    showSignIn();
  }
  perf.endTimer("app-init");

  clerkClient.onAuthChange(async (isSignedIn) => {
    if (isSignedIn === currentSignedIn) {
      return;
    }
    currentSignedIn = isSignedIn;
    if (!isSignedIn) {
      showSignIn();
      return;
    }
    await mountApp();
  });
}

main().catch((error) => {
  console.error("app_init_failed", error);
});
